import validator from 'validator'


const SEARCH_BLACK_LIST = [
  '5G',
  'technology_column',
  'life_column',
  'PCB',
  '_renewableenergy',
  '_heavyequipmajorplayers',
  '_heavyequipsupplychaincheck',
  '_renewableenergystatistics',
  '_taiwanelectricitystatistics',
  '_taipowerstatistics',
  '_renewableenergycopilot',
  '_industrycolumncnc',
  '__machinetoolsmajorplayers',
  'pcbplayers',
  'ccl',
  'smartfactory',
  'iaplayers',
  'ipcassist',
  'ipclecture',
  '_semiequip',
  '_semiequipreport',
  '_foundriescapex',
  '_ipcandroboticsreports',
  '_cobotreport',
  '_linearmotionreport',
  '_industrialrobotsreport',
  '_2Dand3Dmachinevisionreport',
  '_servoanddrivereport',
  '_plcreport',
  '_roboticsensorreport',
  '_speedreducerreport',
  '_metrologyandinspection',
  '_gamingpc',
  '_sectortracker',
  '_fwa',
  '_globalmarketsummary',
  '_commodityintelligence',
  '_twfundamental',
  '_usfundamental',
  '_uscsp',
  '_siliconphotonics',
  '_semifab',
  '_semimaterials',
  '_enterprisedata',
  '_evmakers',
  '_linearmotion',
  '_machinarycnc',
  '_opticallens',
  '_memorychips',
  '_passivecomponents',
  '_pcsmartphone',
  '_sportsrelated',
  '_robotics',
  '_meddevice',
  '_semiosat',
  '_designhouse',
  '_electricalinstrument',
  '_aidatacenters',
  '_energytransition',
  '_networkingdomain',
  '_lmsystems',
  '_printedcircuitboard',
  '_ipc',
  '_semieuipments',
  '_lowearthorbit',
  '_usearningseasons',
  '_evbatteries',
  '_paperpulp',
  '_semitestinterface',
  '_autoparts',
  '_evcharginginfrastructure',
  '_networkingswitch',
  'capital_global_data',
  '_exchangeratenews',
  '_satcom',
  '_automation',
  'versionglobal',
  '_bioplastics',
  '_petrochemical',
];
const SINGLE_SWITCH_LIST = [
  'capital_global_data',
  'versionglobal',
  '_enterpriseglobal',
  '_uaintelligencedata',
];
const STOCK_TW_ONLY_LIST = [
  'capital_tw_i',
];
const checkIsStockTWOnly = (lab) => {
  if (!lab || !lab.available) { return false; }

  const isTaiwanOnly = STOCK_TW_ONLY_LIST.includes(lab?.pathname);

  return isTaiwanOnly;
}
const checkSingleSwitchEnabled = (lab) => {
  if (!lab || !lab.available) { return false; }

  const enabled = SINGLE_SWITCH_LIST.includes(lab?.pathname);

  return enabled;
}
const checkStockInputNeed = (lab) => {
  if (!lab || !lab.available) { return true; }

  const { pathname, products } = lab;
  const noStockInputSingles = products?.filter((product) => {
    let { single_options, single_type } = product;

    if (typeof single_options === 'string' && validator.isJSON(single_options)) {
      single_options = JSON.parse(single_options);
    }

    return single_type === 'aiReport' || ('no_stock_input' in single_options
      && single_options.no_stock_input);
  });

  let isNeeded = noStockInputSingles.length === 0;

  if (!isNeeded) { return isNeeded; }

  for (let i = 0; i < SEARCH_BLACK_LIST.length; i++) {
    const check = SEARCH_BLACK_LIST[i];

    isNeeded = !pathname?.includes(check);

    if (!isNeeded) { return isNeeded; }
  }

  return isNeeded;
}


export { checkIsStockTWOnly, checkSingleSwitchEnabled, checkStockInputNeed }
